import { render } from "./invoice-creation.vue?vue&type=template&id=20e13d68"
import script from "./invoice-creation.vue?vue&type=script&lang=js"
export * from "./invoice-creation.vue?vue&type=script&lang=js"

import "./invoice-creation.vue?vue&type=style&index=0&id=20e13d68&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__